import type { MultiTableViewDefinition } from '@powerportalspro/core';
import { Calendar } from '@powerportalspro/react-calendar';

// Only the meetings held in Teams, as a list of the week.
const views: MultiTableViewDefinition[] = [
  {
    id: '5d8e2c1a-7b4f-4e0a-9c3d-2f6b1a8e4c70',
    displayName: 'Online meetings',
    tables: [
      {
        table: 'appointment',
        fetchXml: `
          <fetch>
            <entity name="appointment">
              <filter>
                <condition attribute="location" operator="eq" value="Microsoft Teams" />
              </filter>
            </entity>
          </fetch>`,
      },
    ],
  },
];

export function CalendarOptionsSample() {
  return <Calendar customViewDefinitions={views} defaultLayout="agenda" height="480px" />;
}
